import Icon, { DownOutlined } from "@ant-design/icons";
import { Space } from "antd";
import FastTooltip from "components/fast_tooltip";
import { useWindowWidth, useWkSelector } from "libs/react_hooks";
import { useMemo } from "react";
import Constants, { ControlModeEnum } from "viewer/constants";
import { getDisabledInfoForTools } from "viewer/model/accessors/disabled_tool_accessor";
import { AnnotationTool, Toolkit, Toolkits } from "viewer/model/accessors/tool_accessor";
import { ToolRadioButtonWithDropdown } from "./tools/tool_helpers";

export const ToolDropdown = () => {
  const toolkit = useWkSelector((state) => state.userConfiguration.activeToolkit);
  const disabledInfoForTools = useWkSelector(getDisabledInfoForTools);
  const windowWidth = useWindowWidth();
  const isWiderScreen = useMemo(() => windowWidth >= Constants.NARROW_SCREEN_WIDTH, [windowWidth]);
  const isViewMode = useWkSelector(
    (state) => state.temporaryConfiguration.controlMode === ControlModeEnum.VIEW,
  );
  const showAllTools = isWiderScreen || toolkit === Toolkit.READ_ONLY_TOOLS || isViewMode;
  if (showAllTools) return null;
  return (
    <ToolRadioButtonWithDropdown
      value={null}
      dropdownItems={Toolkits[toolkit].map((tool) => {
        const isDisabled = disabledInfoForTools[tool.id].isDisabled;
        return {
          key: tool.id,
          disabled: isDisabled,
          label: (
            <FastTooltip
              title={
                isDisabled
                  ? disabledInfoForTools[tool.id].explanation
                  : AnnotationTool[tool.id].description
              }
              placement="left"
            >
              <Space size="small">
                {tool.icon ? <Icon component={tool.icon} /> : null}
                {tool.readableName}
              </Space>
            </FastTooltip>
          ),
        };
      })}
    >
      <DownOutlined />
    </ToolRadioButtonWithDropdown>
  );
};
